export interface BlockWordModalProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
}

export interface BlockedWordModel {
    text: string;
    isTitle: boolean;
}

export enum BuyingOptionEnum {
    FIXED_PRICE = 1,
    BEST_OFFER = 2,
    AUCTION = 3,
}

export interface EbayItemViewModel {
    ID: string;
    Title: string;
    ImageUrl: string | null;
    ItemWebUrl: string;
    ConditionDisplayName: string;
    Location: string | null;
    CurrentPrice: number;
    ShippingPrice:number;
    TotalPrice:number;
    Currency: string | null;
    ItemCreationDate: Date;
    BackEndReciveTime :Date;
    IsFavouriteItem: boolean;
    BuyingOptions: BuyingOptionEnum[];
    Seller: {
        SellerUserName: string;
        SellerRaiting: number;
        SellerPositiveRaitingPercent: number;
    };
}

export interface FavoriteItemModalProps {
    title: string;
    currentPrice:number;
    isOpen: boolean;
    onClose: () => void;
}


export interface FavoriteItemModel {
    name: string;
    conditionPrices: FavouriteItemConditionPrices[];
  }
  
  export interface FavouriteItemConditionPrices {
    conditionID: number;
    price: number | null;
  }


  export const getBaseURL = async (): Promise<string> => {
    try {
      const response = await fetch("/config.json");
      const config = await response.json();
  
      // Determine environment
      const environment = process.env.NODE_ENV === "production" ? "production" : "local";
      return config[environment]?.baseURL || "/";
    } catch (error) {
      console.error("Error loading base URL from config.json:", error);
      return "/";
    }
  };
   